import React, { useEffect, useState } from "react";
import product from "../../assets/product.png";
import "../../styles/ProductView.css";
import Cart from "./Cart";
import { Input, message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  fetchAllOrdersCart,
  removeCart,
  setCoupon,
  clearCoupon,
} from "../../redux/ecommerce/cartSlice";

const MainCart = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const dispatch = useDispatch();

  const {
    ordersCart,
    cart,
    status,
    error,
    couponStatus,
    couponError,
    coupon,
  } = useSelector((state) => state.cart);

  const [couponInput, setCouponInput] = useState("");

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchAllOrdersCart());
    }
  }, [status, dispatch]);

  console.log(ordersCart);

  const orderId = ordersCart[0]?.id;

  const handleVerifyCoupon = () => {
    if (!couponInput.trim()) {
      message.warning("Please enter a coupon code");
      return;
    }
    if (!orderId) {
      message.warning("No active order found");
      return;
    }
    dispatch(setCoupon({ order_id: orderId, coupon: couponInput.trim() }))
      .then((result) => {
        if (result.meta.requestStatus === "fulfilled") {
          message.success("Coupon applied successfully");
        } else {
          message.error("Invalid coupon code");
        }
      });
  };

  const handleClearCoupon = () => {
    dispatch(clearCoupon());
    setCouponInput("");
  };

  return (
    <div className="ProductDetails mb-5">
      <div className="bg-[#FCFBFA] absolute top-0 z-0 w-full h-[110px] store"></div>
      <div className="grid grid-cols-3 max-lg:grid-cols-1 gap-14 max-lg:gap-4 px-20 max-lg:px-5 mt-8">
        <div className="lg:col-span-2">
          <h2 className="text-[#14294F] text-3xl font-bold leading-relaxed mb-3">
            My Cart
          </h2>
          {ordersCart[0]?.carts.map((ca, idx) => {
            return ca.cart == null ? (
              " "
            ) : (
              <Cart
                key={ca.cart?.id}
                id={ca.cart?.id}
                count={ca.cart?.count}
                unite_price={ca.cart?.unite_price}
                color_id={ca.cart?.color_id}
                name={
                  language == "en"
                    ? ca.cart?.Products[0].name_en
                    : ca.cart?.Products[0].name_ar
                }
                image={`https://ecommerce.samoolah.com${ca.cart?.Products[0].image}`}
              />
            );
          })}
          {(!ordersCart[0]?.carts ||
            ordersCart[0]?.carts.every((ca) => ca.cart == null)) && (
              <p className="text-[#737E91] text-lg py-8">Your cart is empty</p>
            )}
        </div>
        <div className="bg-[#FCFBFA] p-4 rounded-3xl">
          <div className="bg-white border-2 border-[#EAA182] rounded-3xl py-6 text-lg">
            <h3 className="text-[#14294F] text-2xl text-center font-bold leading-relaxed mb-5">
              Order Summary
            </h3>
            {ordersCart[0]?.carts.map((ca, idx) => {
              return ca.cart == null ? (
                " "
              ) : (
                <div className="flex items-center justify-between px-5">
                  <p className="text-[#737E91]">
                    x{ca.cart?.count}{" "}
                    {language == "en"
                      ? ca.cart?.Products[0].name_en
                      : ca.cart?.Products[0].name_ar}
                  </p>
                  <p className="text-[#283D63]">{ca.cart?.unite_price} SR</p>
                </div>
              );
            })}

            <hr className="border border-[#FBDED2] my-5" />

            <p className="text-[#A5AFC0] text-base px-4">Shipping</p>
            <div className="flex items-center justify-between mt-3 px-5">
              <p className="text-[#737E91]">Standard Shipping</p>
              <p className="text-[#283D63]">{ordersCart[0]?.shipping} SR</p>
            </div>
            <hr className="border border-[#FBDED2] my-5" />
            <div className="flex items-center justify-between mt-3 px-5">
              <p className="text-[#737E91]">Sub-Total</p>
              <p className="text-[#283D63]">{ordersCart[0]?.sub_total} SR</p>
            </div>
            <div className="flex items-center justify-between mt-3 px-5">
              <p className="text-[#737E91]">Discount</p>
              <p className="text-[#283D63]">{ordersCart[0]?.discount} SR</p>
            </div>
            <div className="flex items-center justify-between mt-3 px-5">
              <p className="text-[#737E91]">Tax</p>
              <p className="text-[#283D63]">{ordersCart[0]?.tax} SR</p>
            </div>
            <hr className="border border-[#FBDED2] my-5" />
            <div className="flex items-center justify-between mt-3 px-5">
              <p className="text-[#283D63]">Order Total</p>
              <p className="text-[#283D63] font-semibold text-xl">
                {ordersCart[0]?.total_cost} SR
              </p>
            </div>
          </div>

          <div className=" relative mb-5">
            <div className="mt-8 flex items-center">
              <button
                onClick={handleVerifyCoupon}
                disabled={couponStatus === "loading"}
                className="text-white rounded-xl px-10 py-3 font-semibold border-2 border-[#FE804A] absolute z-10"
                style={{
                  background:
                    "radial-gradient(50% 50% at 50% 50%, #FE6625 0%, #FFAB88 100%)",
                }}
              >
                {couponStatus === "loading" ? "..." : "Verify"}
              </button>
              <Input
                placeholder="Add coupon code here"
                className="h-[44px] border-0 bg-white coupon_input relative z-0 w-2/3 ml-28"
                value={couponInput}
                onChange={(e) => setCouponInput(e.target.value)}
              />
            </div>
            {coupon && couponStatus === "succeeded" && (
              <div className="mt-3 flex items-center justify-between px-2">
                <p className="text-green-600 text-sm">
                  Coupon "{coupon}" applied
                </p>
                <button
                  onClick={handleClearCoupon}
                  className="text-[#CC0F0F] text-sm hover:underline"
                >
                  Remove
                </button>
              </div>
            )}
            {couponStatus === "failed" && (
              <p className="text-[#CC0F0F] text-sm mt-3 px-2">
                {couponError || "Invalid coupon code"}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="flex justify-end ml-auto mr-14 px-20 max-lg:px-5">
        <Link
          to="/checkout"
          className="bg-[#FE9B71] text-white rounded-full px-14 py-3 my-5 font-semibold"
        >
          Checkout
        </Link>
      </div>
    </div>
  );
};

export default MainCart;
